(()=>{
  let busy=false;
  const page=()=>document.querySelector('[data-sos-cart-page]');
  if(!page())return;
  function lock(value){busy=value;const current=page();current.setAttribute('aria-busy',String(value));current.querySelectorAll('button,input,textarea').forEach(el=>el.disabled=value);}
  function replace(html,key){
    const current=page();
    const note=current.querySelector('[name=note]')?.value;
    const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-sos-cart-page]');
    if(!next)throw Error(current.dataset.error);
    current.replaceWith(next);
    if(note!==undefined&&next.querySelector('[name=note]'))next.querySelector('[name=note]').value=note;
    const focus=key?next.querySelector('[data-line-key="'+CSS.escape(key)+'"] input'):null;
    (focus||next.querySelector('h1')).focus({preventScroll:true});
    next.querySelector('[data-cart-page-status]').textContent=next.dataset.updated;
  }
  async function change(row,quantity){
    if(busy)return;
    const current=page();const feedback=current.querySelector('[data-cart-page-status]');
    if(!Number.isSafeInteger(quantity)||quantity<0){row.querySelector('input').reportValidity();return;}
    feedback.textContent='';feedback.removeAttribute('data-error');lock(true);
    try{
      const response=await fetch(current.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:row.dataset.lineKey,quantity,sections:[current.dataset.sectionId],sections_url:current.dataset.cartUrl})});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||current.dataset.error);
      const html=result.sections?.[current.dataset.sectionId];
      if(!html){location.reload();return;}
      replace(html,row.dataset.lineKey);
      document.dispatchEvent(new CustomEvent('sos:cart-updated',{detail:result}));
    }catch(error){feedback.textContent=error.message||current.dataset.error;feedback.setAttribute('data-error','');}
    finally{lock(false);}
  }
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-step],[data-remove]');
    if(!target||!page().contains(target))return;
    event.preventDefault();
    const row=target.closest('[data-line-key]');
    const quantity=target.hasAttribute('data-remove')?0:Math.max(0,Number(row.querySelector('input').value)+Number(target.dataset.step));
    change(row,quantity);
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-sos-cart-page] input[name="updates[]"]')&&event.target.reportValidity())change(event.target.closest('[data-line-key]'),Number(event.target.value));
  });
  document.addEventListener('submit',event=>{if(busy&&event.target.matches('[data-cart-page-form]'))event.preventDefault();});
  document.querySelector('#cart-dialog')?.addEventListener('close',async()=>{
    if(busy)return;const current=page();lock(true);
    try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({sections:[current.dataset.sectionId],sections_url:current.dataset.cartUrl})});if(!response.ok)throw Error(current.dataset.error);const result=await response.json();if(!result.sections?.[current.dataset.sectionId]){location.reload();return;}replace(result.sections[current.dataset.sectionId]);}
    catch(error){current.querySelector('[data-cart-page-status]').textContent=error.message;}
    finally{lock(false);}
  });
})();
